import { storeSettings } from "@/stores/settings.js";
import $axios from "@/axios";

export default {
  get: async function () {
    await $axios
      .post("/api/admin/settings_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.credits = res.data.settings.credits;
          storeSettings.points = res.data.settings.points;
          storeSettings.logos = res.data.settings.logos;
          storeSettings.styles = res.data.settings.styles;
          storeSettings.checkout = res.data.settings.checkout;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  //請求購物金設定
  getCredits: async function () {
    await $axios
      .post("/api/admin/settings_credit_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.credits = res.data.credits;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  //請求點數設定
  getPoints: async function () {
    await $axios
      .post("/api/admin/settings_point_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.points = res.data.points;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  getLogos: async function () {
    await $axios
      .post("/api/admin/settings_logo_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.logos = res.data.logos;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
